export const CREATE_PURCHASE_CHALLAN_RETURN = 'CREATE_PURCHASE_CHALLAN_RETURN';
export const GET_PURCHASE_CHALLAN_RETURNS = 'GET_PURCHASE_CHALLAN_RETURNS';
export const GET_PURCHASE_CHALLAN_RETURNS_PAGE = 'GET_PURCHASE_CHALLAN_RETURNS_PAGE';
export const PURCHASE_CHALLAN_RETURN_REQUEST = 'PURCHASE_CHALLAN_RETURN_REQUEST';
export const PURCHASE_CHALLAN_RETURN_REQUEST_SUCCESS = 'PURCHASE_CHALLAN_RETURN_REQUEST_SUCCESS';
export const UPDATE_PURCHASE_CHALLAN_RETURN = 'UPDATE_PURCHASE_CHALLAN_RETURN';
export const DELETE_PURCHASE_CHALLAN_RETURN = 'DELETE_PURCHASE_CHALLAN_RETURN';
export const PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE = 'PURCHASE_CHALLAN_RETURN_REQUEST_FAILURE';
export const SET_PURCHASE_CHALLAN_RETURN_ORDERS = 'SET_PURCHASE_CHALLAN_RETURN_ORDERS';